import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "assets/css/index.scss";
import "assets/css/custom-select-field.scss";
import "assets/css/custom-date-component.scss";
import FormPage from "form/page/form-page";

ReactDOM.render(<FormPage />, document.getElementById("root"));